import React, { PropsWithChildren } from 'react';
import { useDispatch } from 'react-redux';

import { useReplyOnboardingContext } from '../../utils/replyOnboardingContext';
import { useMessageContext } from '../../utils/messageContext';
import { Responsive } from '@cian/ui-kit';
import { ChatMessageSwipeReply } from '../ChatMessageSwipeReply';
import { ReplyOnboardingTooltip } from '../ReplyOnboardingTooltip';
import { setActiveReplyMessage } from '../../actions/chat';

interface IChatMessageReplyLayoutProps {
  bubbles: React.ReactNode;
}

export const ChatMessageReplyLayout: React.FC<PropsWithChildren<IChatMessageReplyLayoutProps>> = React.memo(
  function ChatMessageReplyLayout({ children, bubbles }) {
    const { messageId } = useMessageContext();

    const { isReplyOnboardingTargetMessage } = useReplyOnboardingContext();
    const isReplyOnboardingTarget = isReplyOnboardingTargetMessage(messageId);

    const dispatch = useDispatch();
    const handleSwipe = React.useCallback(() => {
      dispatch(setActiveReplyMessage(messageId));
    }, [dispatch, messageId]);

    return (
      <>
        <Responsive desktop>
          <ReplyOnboardingTooltip isOnboardingTarget={isReplyOnboardingTarget}>{children}</ReplyOnboardingTooltip>
          {bubbles}
        </Responsive>

        <Responsive phone tablet>
          <ChatMessageSwipeReply
            onSwipe={handleSwipe}
            isSwipeOnboardingTarget={isReplyOnboardingTarget}
            bubbles={bubbles}
          >
            {children}
          </ChatMessageSwipeReply>
        </Responsive>
      </>
    );
  },
);
